import { requestPasswordReset } from '@/helper/apicalls';

export async function passwordResetAction({ request, params }: any) {
  // eslint-disable-next-line unicorn/no-null
  return request.method == 'POST' ? requestPasswordReset(params.id) : null;
}
